import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const FaceLivenessV3InputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-eye', title: 'Face Liveness (v3)', subtitle: 'v3 liveness check via Surepass' }}
        fileFields={[
            { name: 'file', label: 'Face image', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{ path: '/surepass/face/liveness-v3' }}
        consentReportType="face-liveness"
        submitLabel="Run Liveness Check"
        successSummary="Liveness v3 check complete"
        errorSummary="Liveness v3 check failed"
        confirmHeader="Confirm liveness v3 check"
        confirmAcceptLabel="Yes, check"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Face Liveness v3 Result', icon: 'pi-eye' }}
    />
);

export default FaceLivenessV3InputComponent;
